import { useContextState } from "../../../../hooks/theme"

const useStyles = () => {
    const { colors } = useContextState()

    return {
        noSelected: {
            '&.MuiTypography-root': {
                fontSize: '12px',
                color: colors.color28,
                fontWeight: '400',
                marginBottom: '10px',
            },
        },
        labels: {
            '& .MuiFormControlLabel-label': {
                fontSize: '.9rem',
                color: colors.color13
            },
            '& .MuiTypography-root': {
                fontSize: '.9rem',
                color: colors.color13,
                fontWeight: '400'
            },
        }
    }
}

export { useStyles }
